import Tooltip from "components/forecast-table/wind-state/tooltip/tooltip"

export default function WindStateTooltipPlugin($pool) {
  return function run(eventName, payload) {
    const { tableName, node } = payload
    if (eventName !== "Table:connectHeaders") return
    if (tableName !== "basic") return

    $pool.push("Table:connectHeaders::finish", () => {
      Array.from(node.querySelectorAll(".wind-state-tip")).forEach((el) => {
        const tooltip = new Tooltip(el)
        tooltip.init()
      })
    })
  }
}
